import { useTranslation } from "react-i18next";
import SideBarItemList from "../../../components/sidebar/SideBarItemList";
import SolarSmartphoneLinear from "../../../components/icons/SolarSmartphoneLinear";

const MobileSideBarMenu = () => {
    const { t } = useTranslation(["Mobile", "common"]);
    return (
        <SideBarItemList
            title={t("sideTitle")}
            icon={(<SolarSmartphoneLinear />)}
            itemsList={[
                {
                    label: t("sideItemNotifications"),
                    to: "/mobile/notifications",
                    startsWith: "/mobile/notifications",
                },
            ]}
        />
    );
};

export default MobileSideBarMenu;
